import { APIService } from '@apparel/core/api/APIService';
import { ApparelNotification, ApparelNotificationType } from '@model/ApparelNotification';
import { Repository } from '@repositories/Repository';
import { AxiosRequestConfig } from 'axios';

export class ApparelNotificationRepository extends Repository {
    api = APIService.createEndpoint('apparel-notifications');

    public fetchApparelNotificationsForCurrentUser(params$: { [key: string]: any } = {}) {
        const { search, ...params } = params$ || {};

        return ApparelNotification.index({
            q: search,
            fields: ['id', 'hidden', 'read', 'message', 'link', 'category', 'created_at'],
            ...params,
        });
    }

    public updateNotification(
        id: number,
        notification?: Partial<ApparelNotificationType>,
        config: AxiosRequestConfig = {},
    ) {
        return this.api.put(`/${id}`, notification, this.withParams(config, { fields: 'id' }));
    }
    public readAllNotifications(category = 'all') {
        return this.api.get(`read-all`, {
            params: {
                category,
            },
        });
    }
    public hideAllNotifications(category = 'all') {
        return this.api.get(`hide-all`, {
            params: {
                category,
            },
        });
    }
    public categoryUnreadCountNotifications() {
        return this.api.get(`category-unread-count`);
    }
}
